module.exports = __webpack_public_path__ + "img/choose-up-Up Social.960cfa9c.png";